<template>
  <div >

    <table class="tb">
      <tr >
        <th width="150px" >功能</th>
        <th width="400px">启用状态</th>
        <th>功能说明</th>
      </tr>
      <tr>
        <td>自动评价</td>
        <td >
          <el-radio-group v-model="autoRate.send">
            <el-radio :label="1">开启自动发货</el-radio>
            <el-radio :label="0">关闭自动发货</el-radio>
          </el-radio-group >
        </td>
        <td><span>开启自动发货</span></td>
      </tr>
      <tr>
        <td>商品类型</td>
        <td >
          <el-radio-group v-model="autoRate.virtual">
            <el-radio :label="'0'">虚拟商品</el-radio>
            <el-radio :label="'1'">实物商品</el-radio>
          </el-radio-group >
        </td>
        <td><span>选择商品类型</span></td>
      </tr>
      <tr>
        <td>禁止发货商品ID</td>
        <td  style="text-align: center"><el-input v-model="autoRate.blackId" type="textarea" :rows="5" ></el-input></td>
        <td><span>填写禁止自动发货的商品ID(用逗号分隔)，例如：31415926, 31415927</span></td>
      </tr>
      <tr>
        <td>禁止发货买家</td>
        <td  style="text-align: center"><el-input v-model="autoRate.blackBuyer" type="textarea" :rows="5" ></el-input></td>
        <td><div><span>填写禁止自动发货的买家(用逗号分隔)，例如：AAE-QthPAAgc,DgPqUGnvs</span></div>
                 <div><span>用真实的买家旺旺，转换为加密形式</span></div>
        </td>
      </tr>
    </table>
    <div class="btndiv">
      <el-button  type="primary" @click="saveRate">保存自动发货设置</el-button>
    </div>
    <div style="margin-left: 30px"> <span>真实旺旺：</span><el-input v-model="buyers" size="mini" style="width: 300px" clearable></el-input>
      <el-button type="success" size="small"  @click="getOpenIds" >加密</el-button>
    </div>
    <div style="margin-left: 30px; margin-top: 10px;display: flex"><span>加密旺旺：</span><el-input v-model="openIds" type="textarea"  style="width: 300px" :rows="3" ></el-input></div>
  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"

    export default {
        name: "AutoSend",
      data(){
          return {
            autoRate: {
              nick: '',
              sessionkey: '',
              createTime: '',
              deadLine: '',
              valid: 0,
              send: 0,
              memo: 0,
              sellerMemo:'',
              sellerFlag: 2,
              virtual:'0',
              delay: 0,
              rateType: 0,
              attack: 0,
              rateAttack: '',
              rateBlack: '',
              blackId:'',
              blackBuyer:'',
              rateMoban: [{content: '好评'}, {content: '还是好评'}]
            },
            buyers:'',
            openIds:'',
            version: '1',
          }

      },
      methods:{
        saveRate(){
          /*let curver = parseInt(this.version);
          if(curver <= 2 ){
            this.$message.error('该版本不支持此功能，请升级版本');
            return;
          }*/
          let param = {
            nick: storage.get("nick"),
            sessionkey: "",
            createTime: this.autoRate.createTime,
            deadLine: this.autoRate.deadLine,
            valid: this.autoRate.valid,
            send: this.autoRate.send,
            virtual: this.autoRate.virtual,
            memo: this.autoRate.memo,
            sellerMemo: this.autoRate.sellerMemo,
            sellerFlag: this.autoRate.sellerFlag,
            delay: this.autoRate.delay,
            rateType: this.autoRate.rateType,
            attack: this.autoRate.attack,
            rateAttack: this.autoRate.rateAttack,
            rateBlack: this.autoRate.rateBlack,
            blackId: this.autoRate.blackId,
            blackBuyer: this.autoRate.blackBuyer
            //moban: this.mbstr,
            //rateMoban: this.autoRate.rateMoban
          }

          $api.post("/auto/addAuto", param, response =>{
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok") {
              this.$message({
                type: 'success',
                message: '自动发货设置成功！'
              })
            }else {
              this.$message.error(dataResult);
            }
          })
        },
        getRateUser(){
          let param = {
            nick: storage.get("nick")
          }
          $api.post("/auto/getAuto", param, response => {
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok") {
              if(dataResult.data.auto != null){
                this.autoRate = dataResult.data.auto;
              }else{
                this.autoRate.nick = storage.get("nick");
              }
              console.log("success");
            }else {
              this.$message.error(dataResult);
            }
          })
        },
        getOpenIds(){
          let param = {
            nick: storage.get("nick"),
            buyers: this.buyers
          }
          $api.post("/auto/openId", param, response =>{
            let dataResult = response.data;
            console.log(response);
            if(dataResult.state == 1){
              this.openIds = dataResult.data;
            }
          })
        },
        getVersion:function(){
          let param={
            nick:storage.get("nick")
          }
          $api.post("/getVersion", param,response=>{
            let dataResult = response.data;
            if(dataResult.state=="1" && dataResult.message == "ok"){
              this.version = dataResult.data;
            }else{
              console.log(dataResult.message);
            }
          })
        },
      } ,
      mounted() {
        this.getRateUser();
      }

    }
</script>

<style scoped>
  .main {
    background-color: #FFF;
    min-height: 400px;
    margin: 0px auto 0;
    border-radius: 10px;
    text-align: left;
    padding-left: 20px;
    padding-top: 10px;
  }
  .tb{
    width:100%;
    border-collapse: collapse;
    font-size: 12pt;
  }
  .tb th：{background-color: gray}

  .tb tr th, .tb tr td { border:1px solid #409EFF; }

  .tb td, .tb th{ height: 70px}

  .btndiv{
    height: 80px;
    margin-top: 20px;
    padding-left: 200px;
  }

</style>



// WEBPACK FOOTER //
// src/auto/AutoSend.vue